import { usePunditUserContext } from "react/contexts/punditUserContext";

export const useHasCommunityCodeSnippets = () => {
  const { currentCommunity } = usePunditUserContext();

  return Boolean(
    currentCommunity?.v4_head_js_code?.trim() ||
    currentCommunity?.v4_head_snippet_code?.trim(),
  );
};
